'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["object", "hasToggle", "searchQuery", "defaultOpen", "children", "dataTourStep", "ticketToggleEnabled", "options", "currentInboxId"];
import { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import PropertyGroupToggle from 'FormsUI/components/editor/leftPanel/properties/PropertyGroupToggle';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { TOGGLE_PROPERTY_ACCORDION } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { connect } from 'react-redux';
import { getInboxes, getCurrentInboxId } from 'FormsUI/selectors/Inboxes';
import { fetchInboxesAndCurrentInbox } from 'FormsUI/actions/Inboxes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertiesGroup = _ref => {
  let {
      object: {
        propertiesCount = 0,
        objectTypeLabel = '',
        objectTypeId = ''
      },
      hasToggle = false,
      searchQuery = '',
      defaultOpen = false,
      children,
      dataTourStep = '',
      ticketToggleEnabled,
      options,
      currentInboxId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const dispatch = useDispatch();
  const hasProperties = searchQuery.length > 0 || propertiesCount > 0;
  const hasValidInboxesForTicketCreation = options.length > 0 || currentInboxId !== null;
  /**
   * If the form has a ticket creation toggle and there are valid inboxes for ticket creation, we want to show the property group toggle.
   */
  const showPropertyGroupToggle = hasToggle && hasValidInboxesForTicketCreation;
  useEffect(() => {
    dispatch(fetchInboxesAndCurrentInbox());
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      justify: "start",
      align: "start",
      "data-test-id": "properties-group",
      "data-tour-step": dataTourStep,
      padding: "600",
      paddingBlockStart: "800",
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 1,
        children: /*#__PURE__*/_jsx(AccordionItem, {
          "data-test-id": `${objectTypeLabel.toLowerCase()}-properties-accordion`,
          "data-test-property-group-type": objectTypeLabel.toUpperCase(),
          disabled: !hasProperties,
          title: /*#__PURE__*/_jsx(Fragment, {
            children: /*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsx("strong", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  options: {
                    objectTypeLabel
                  },
                  message: "editor.form.properties.propertiesGroup",
                  "data-test-id": `${objectTypeLabel.toLowerCase()}-accordion-heading`
                })
              }), "\xA0", `(${propertiesCount})`]
            })
          }),
          onOpenChange: isOpen => {
            trackEditorInteraction(TOGGLE_PROPERTY_ACCORDION, {
              value: [objectTypeId, ...(isOpen ? ['isOpened'] : ['isClosed'])]
            });
          },
          defaultOpen: defaultOpen,
          children: children
        })
      }), showPropertyGroupToggle && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(PropertyGroupToggle, Object.assign({
          ticketToggleEnabled: ticketToggleEnabled
        }, rest))
      })]
    }), /*#__PURE__*/_jsx(HR, {
      margin: "0"
    })]
  });
};
const mapStateToProps = state => ({
  options: getInboxes(state),
  currentInboxId: getCurrentInboxId(state)
});
export default connect(mapStateToProps)(PropertiesGroup);